import React from "react"
import classnames from "classnames"
import { styles as inputStyles } from "@infotech/uikit-input-core"
import { withStyleNames } from "@infotech/uikit-core"
import { withHandlers } from "recompact"
import ArrowIcon from "src/icons/arrow.svg"
import styles from "./styles.css"

const enhance = withStyleNames(`InputCore`)
const Input = enhance(`input`)

/* TODO: Very bad, this component works fine only wirh redux form */
export default withHandlers({
  onChange: ({ input: { onChange } }) => ({ target: { value } }) => {
    if (/^\d*$/.test(value)) {
      onChange(value)
    }
  },
  onBlur: ({ input: { onBlur, value } }) => () => onBlur(value),
  onIncrement: ({ input: { onChange, value } }) => () => {
    let inputValue = value
    if (inputValue === ``) {
      inputValue = `0`
    }
    const newValue = (parseInt(inputValue, 10) + 1).toString()
    onChange(newValue)
  },
  onDecrement: ({ input: { onChange, value } }) => () => {
    const inputValue = value
    if (inputValue === `0` || inputValue === ``) {
      return
    }
    const newValue = (parseInt(inputValue, 10) - 1).toString()
    onChange(newValue)
  },
})(
  ({
    input: { value, placeholder, disabled },
    onChange,
    onIncrement,
    onDecrement,
    valid,
    maxlength,
  }) => (
    <div className={styles[`input-wrapper`]}>
      <Input
        styles={inputStyles}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        invalid={String(!valid)}
        maxLength={String(maxlength)}
      />
      <button
        type="button"
        onClick={onIncrement}
        className={classnames(styles[`change-button`], styles.increment, {
          [styles.disabled]: disabled,
        })}
        disabled={disabled}
        tabIndex="-1"
      >
        <ArrowIcon />
      </button>
      <button
        type="button"
        className={classnames(styles[`change-button`], styles.decrement, {
          [styles.disabled]: disabled,
        })}
        onClick={onDecrement}
        disabled={disabled}
        tabIndex="-1"
      >
        <ArrowIcon />
      </button>
    </div>
  ),
)
